







import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import 'firebase/auth';

@Component({})
  export default class ProfileAvatar extends Vue {
      @Prop({required: false, default: 100}) height!: number;
      @Prop({required: false, default: 100}) width!: number;
      @Prop({
          required: false,
          default: require('@/assets/images/profile/no-avatar.svg'),
      })
      profileAvatar!: string;
  }
